import React, { useContext, createContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RendererContext = createContext(() => {
    throw new Error('Not implemented yet.');
});
export function useRenderer() {
    return useContext(RendererContext);
}
export function RendererProvider({ renderer, children }) {
    return (React.createElement(RendererContext.Provider, { value: renderer }, children));
}
//# sourceMappingURL=renderer-context.js.map